const map = {
	"./features-service1.png": 68532,
	"./features-service10.png": 7406,
	"./features-service11.png": 50423,
	"./features-service12.png": 66140,
	"./features-service13.png": 79205,
	"./features-service2.png": 87439,
	"./features-service3.png": 48422,
	"./features-service4.png": 63878,
	"./features-service5.png": 44592,
	"./features-service6.png": 14443,
	"./features-service7.png": 93314,
	"./features-service8.png": 40261,
	"./features-service9.png": 10844
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33836;